import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';
import {
    MatDialogModule, MatButtonModule, MatSelectModule, MatRadioModule,
    MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule,
    MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter, MatCardModule,
    MatTooltipModule, MatMenuModule, MatProgressBarModule, MatIconModule,
    MatSnackBarModule, MatDividerModule, MatAutocompleteModule
} from '@angular/material';

import { AppDateAdapter, APP_DATE_FORMATS } from '../core/dateformat';

import { NgxMaskModule } from 'ngx-mask';


import * as LayOut from './layout/index';
import * as Login from './login/index';
import * as Control from './controls/index';
import * as Pipe from './pipes/index';
import * as Directives from './directives/index';
import * as Common from './common/index';
import * as Dashboard from './dashboard/index';
import { pipe } from 'rxjs';
import {
    PdfViewerModule, LinkAnnotationService, BookmarkViewService, MagnificationService, ThumbnailViewService,
    ToolbarService, NavigationService, TextSearchService, TextSelectionService, PrintService, FormFieldsService
} from '@syncfusion/ej2-angular-pdfviewer';
import { PDFMessageComponent } from './common/pdfmessage.component';
import { AutocompleteComponent } from './controls/autocomplete.component';
import { MobileattachlinkforpictureComponent } from './common/mobileattachlinkforpicture.component';
import { cspFormsService } from '../services/cspforms.service';

const MODULES = [
    NgxMaskModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatProgressBarModule,
    MatIconModule,
    MatSnackBarModule,
    ClickOutsideModule,
    PdfViewerModule,
    MatDividerModule,
    MatAutocompleteModule
]

const PIPES = [
    Pipe.FilterPipe,
    Pipe.ContentFilterPipe,
    Pipe.RowFilterPipe,
    Pipe.PhonePipe,
    Pipe.ExtensionPipe,
    Pipe.DateFormatPipe,
    Pipe.FieldBasedFilterPipe,
    Pipe.SafeHtmlPipe,
    Pipe.dateFPipe,
    Pipe.FormatPipe,
    Pipe.ContentStatusPipe,
    Pipe.MenuTypeFilter,
    Pipe.TxtLanguageContentPipe,
    Pipe.PDFFormFilterPipe,
    Pipe.TrimPipe,
    Pipe.ReportFormFilterPipe,
    Pipe.PermitFilterPipe
    


]

const DIRECTIVES = [
    Directives.AutofocusDirective,
    Directives.DisablecopyDirective,
    Directives.DisableCutDirective,
    Directives.DisablepasteDirective,
    Directives.DisableEnterDirective
]

const CONTROLS = [
    Control.MessageControl,
    Control.AddressControl,
    Control.GeoAddressControl,
    Control.PhoneNumberControl,
    Control.CodedDropDownControl,
    Control.EmailControl,
    Control.NumberControl,
    Control.TextControl,
    Control.SelectControl,
    Control.DateControl,
    Control.RadioControl,
    Control.CheckControl,
    Control.ButtonControl,
    Control.LoadingControl,
    Control.PasswordControl,
    Control.ParameterControl,
    Control.TextEditorControl,
    Control.IGTextEditorControl,
    Control.InfgTextEditorControl,
    Control.FileControl,
    Control.TimeControl,
    Control.PdfControl,
    Control.FilewithmobileComponent,
    Control.AutocompleteComponent,
    Control.FilewithimagepreviewComponent
]

const COMPONENTS = [
    LayOut.HeaderComponent,
    LayOut.FooterComponent,
    LayOut.LeftMenuComponent,
    Login.LoginComponent,
    Login.PasswordRecoveryComponent,
    Login.ResetPasswordComponent,
    Login.ProfileInfoComponent,
    Login.UserInfoComponent,
    Common.AlertComponent,
    Common.DenyComponent,
    Common.AuthenticationComponent,
    Common.UnderConstructionComponent,
    Common.PDFMessageComponent,
    Common.MobileattachlinkComponent,
    Common.MobileattachlinkforpictureComponent,
    Dashboard.NewsLetterDashboardComponent
]

const ENTRYCOMPONENTS = [
    Login.LoginComponent,
    Login.ProfileInfoComponent,
    Login.UserInfoComponent,
    Common.AlertComponent,
    Common.DenyComponent,
    Common.AuthenticationComponent,
    Common.PDFMessageComponent,
    Common.MobileattachlinkComponent,
    Common.MobileattachlinkforpictureComponent,
    Dashboard.NewsLetterDashboardComponent
]

// Shared Module Screen Declarations and Exports

@NgModule({
    imports: [
        ...MODULES
    ],
    declarations: [
        ...PIPES,
        ...DIRECTIVES,
        ...CONTROLS,
        ...COMPONENTS, 
    ],
    exports: [
        ...PIPES,
        ...DIRECTIVES,
        ...CONTROLS,
        ...COMPONENTS
    ],
    entryComponents: [
        ...ENTRYCOMPONENTS
    ],
    providers: [
        LinkAnnotationService, BookmarkViewService, MagnificationService,
        ThumbnailViewService, ToolbarService, NavigationService, TextSearchService, TextSelectionService, PrintService, FormFieldsService,cspFormsService,
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    ]
})
export class SharedModule { }


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/shared.module.ts